<template>
  <!-- 新增 修改 供应商列表 -->
  <Modal
    class="create-update-modal"
    :mask-closable="false"
    :closable="false"
    :title="actionText + '供应商'"
    v-model="modal">
    <Form ref="handleForm" :model="handleForm" :rules="handleValidate" :label-width="110">
      <Row>
        <Col :sm="24" :xs="24">
          <FormItem label="供应商名称:" prop="name">
            <Input v-model.trim="handleForm.name" placeholder="请输入" maxlength="20" show-word-limit />
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="供应商类别:" prop="supplierCode">
            <Select v-model="handleForm.supplierCode"  style="width: 100%;">
              <Option v-for="item in supplierCodeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :sm="24" :xs="24">
          <FormItem label="备注:" prop="remark">
            <Input v-model.trim="handleForm.remark" placeholder="请输入" maxlength="50" show-word-limit />
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" @click="hide" :disabled="loading">取消</Button>
      <Button type="primary" :loading="loading" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '../../api'
import { mapGetters } from 'vuex'
export default {
  name: 'SupplierCreateUpdate',
  data () {
    return {
      modal: false,
      loading: false,
      action: 'create',
      dataIndex: null,
      handleForm: {
        supplierId: '',
        name: '',
        remark: '',
        supplierCode: ''
      },
      handleValidate: {
        name: [
          { required: true, whitespace: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        supplierCode: [
          { required: true, whitespace: true, message: '请输入供应商类别', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (!this.supplierCodeList.length) {
      this.$store.dispatch('supplier/getSupplierCode')
    }
  },
  computed: {
    actionText () {
      return this.action === 'create' ? '新增' : '编辑'
    },
    ...mapGetters('supplier', ['supplierCodeList'])
  },
  methods: {
    show (action = 'create', data = {}, index) {
      // console.log(this.supplierCodeList)
      this.action = action
      if (this.action === 'update') {
        this.handleForm = {
          supplierId: data.id,
          name: data.name,
          remark: data.remark,
          supplierCode: data.supplierCode
        }
        this.dataIndex = index
      }
      this.modal = true
    },
    hide () {
      this.$refs['handleForm'].resetFields()
      this.handleForm.supplierId = ''
      this.dataIndex = null
      this.loading = false
      this.modal = false
    },
    submit () {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.submitForm()
        } else {
          this.$Message.error('请填写必填项目!')
        }
      })
    },
    submitForm () {
      let queryParams = {
        ...this.handleForm
      }
      let submitApi = api.supplier.supplierCreateUpdate
      if (this.action !== 'update') {
        delete queryParams.supplierId
      }
      this.loading = true
      submitApi(queryParams).then(res => {
        this.$emit('success', this.action, {
          ...queryParams
        }, this.dataIndex)
        this.$Message.success(this.actionText + '成功！')
        this.hide()
      }).catch(err => {
        this.$Message.error(this.actionText + '失败：' + err.message)
      }).then(() => {
        this.loading = false
      })
    }
  }
}
</script>
